export default __webpack_public_path__ + "static/media/flag14.500afeb9.png";